import { render, staticRenderFns } from "./CompThgForm.vue?vue&type=template&id=75e2d5c7"
import script from "./CompThgForm.vue?vue&type=script&lang=js"
export * from "./CompThgForm.vue?vue&type=script&lang=js"
import style0 from "./CompThgForm.vue?vue&type=style&index=0&id=75e2d5c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports